window.APR_DATE_FORMAT = 'MMM D, YYYY';

require('../../shared/js/pusher-channels');

window._ = require('lodash');
window.Cookies = require('js-cookie');
window.Pusher = require('pusher-js');

window.googleMapsConfig = {
    key: window.apr.google_api_key,
    v: window.apr.google_api_version,
    libraries: 'places',
    channel: 'web',
    language: 'en'
};

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.moment = require('moment');

window.$ = window.jQuery = require('jquery');
import tether from 'tether';
window.Tether = tether;
require('bootstrap');
require('parsleyjs');
require('parsleyjs/src/extra/validator/words');
require('sweetalert');

window.Parsley.addValidator('isNull', {
	validateString: function(value) { return value != 'null'; },
	messages: { en: 'Select a package', }
});

window.Parsley.addValidator('isNullDirection', {
	validateString: function(value) { return value != 'null'; },
	messages: { en: 'Select a direction', }
});

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');
require('vue-resource');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo";

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
